import React from 'react';
import PropTypes from 'prop-types';

const HomePageAwardListItem = (props) => {
    return (
        <li>
            <i className="fa fa-star" />
            <a href={props.url} className="award">{props.name}</a> - {props.giver}
            <i className="fa fa-star" />
        </li>
    );
};

HomePageAwardListItem.propTypes = {
    name: PropTypes.string.isRequired,
    giver: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default HomePageAwardListItem;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageAwardListItem.js